exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "button[data-v-521fdbae]:focus{outline:0}.btn-info[data-v-521fdbae]{border-radius:5px 0 0 5px!important}", ""]);

// exports
